(function () {
  'use strict';

  class HdsSplitSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.slides = Array.from(this.track.children).filter(
        (el) => !el.classList.contains('content-blocks__ignore')
      );
      if (this.slides.length === 0) return;

      this.progress = this.querySelector('[data-progress]');
      this.progressFill = this.querySelector('[data-progress-fill]');
      this.counterCurrent = this.querySelector('[data-counter-current]');
      this.counterTotal = this.querySelector('[data-counter-total]');
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');

      if (this.counterTotal) this.counterTotal.textContent = this.slides.length;

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.step(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.step(1));
      }

      this.onScroll();
    }

    onScroll() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const slideCount = this.slides.length;

      if (max <= 0) {
        if (this.progress) this.progress.style.setProperty('--progress-ratio', '0');
        if (this.counterCurrent) this.counterCurrent.textContent = '1';
        this.updateButtons(0, 0);
        return;
      }

      const ratio = Math.min(Math.max(this.track.scrollLeft / max, 0), 1);

      if (this.progress) {
        this.progress.style.setProperty('--progress-ratio', ratio.toFixed(4));
      }

      if (this.counterCurrent) {
        const slideWidth = this.track.clientWidth;
        const index = Math.round(this.track.scrollLeft / slideWidth);
        this.counterCurrent.textContent = Math.min(index + 1, slideCount);
      }

      this.updateButtons(this.track.scrollLeft, max);
    }

    updateButtons(scrollLeft, max) {
      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft >= max - 1;
      if (this.prevBtn) this.prevBtn.toggleAttribute('aria-disabled', atStart);
      if (this.nextBtn) this.nextBtn.toggleAttribute('aria-disabled', atEnd);
    }

    step(direction) {
      const width = this.track.clientWidth;
      const max = Math.max(0, this.track.scrollWidth - width);
      const target = Math.max(0, Math.min(this.track.scrollLeft + width * direction, max));
      this.track.scrollTo({ left: target, behavior: 'smooth' });
    }
  }

  if (!customElements.get('hds-split-slider')) {
    customElements.define('hds-split-slider', HdsSplitSlider);
  }
})();
